import { Component, inject } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { I18nService } from "@bitwarden/common/abstractions/i18n.service";

@Component({
  selector: "app-classification-item-renderer",
  templateUrl: "../desc-renderer.component.html",
})
export class ClassificationItemRenderComponent implements ICellRendererAngularComp {
  title!: string;
  subtitle = "";

  private i18nService = inject(I18nService);

  agInit(params: ICellRendererParams): void {
    this.setData(params);
  }

  setData(params: ICellRendererParams) {
    this.title = params.data.name
      ? `${params.data.name} (${params.data.linkedTransactionCount})`
      : this.i18nService.t("classificationNameUnavailable");
  }

  refresh(params: ICellRendererParams): boolean {
    this.setData(params);
    return true;
  }
}
